// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lA-r","question":"styles_question__2RLRm","inputVisibleButton":"styles_inputVisibleButton__Y-tYt","note":"styles_note__3uj-2"};